<template>
  <CheckboxGroup v-model="info.defaultValue" :size="size">
    <Checkbox
      :label="item.value"
      v-for="item in info.form.options.staticList"
      :key="item.value"
      :border="info.form.border"
      :disabled="info.form.disabled||!info.isNew">
      {{item.label}}
    </Checkbox>
  </CheckboxGroup>
</template>
<script>
import { baseComponentMixins } from '../mixins'


export default {
  name: 'BaseCheckbox',
  mixins: [ baseComponentMixins ],
  created() {
    if (!(this.info.defaultValue instanceof Array)) {
      this.info.defaultValue = []
    }
  },
}
</script>